// We need vehicle images in the gallery to be of a specific size in order to have predictable
// layout, thus, we keep vehicle image size in one place since component like ./Placeholder
// also needs this information.
export const GalleryImageSize = {
  width: 230,
  height: 150,
};
